import {
  startListening,
  trackEvent,
  isAnyOf,
  resetMarketingMeta,
  updateReferrerId,
} from '@betty/toolkit/state';
import {
  fetchRegistrationConfig,
  removeStep,
  restoreStep,
  skipStep,
} from '../registrationConfig/registrationConfig.slice';
import {
  resetRegistrationData,
  selectRegistrationFormConfigId,
  selectRegistrationFormData,
  setFormDataConfigId,
  setReturnToSummary,
  setValidationErrors,
  submitRegistrationForm,
  updateRegistrationData,
} from './registrationForm.slice';
import { fetchRegistrationOffers } from '../registrationOffers/registrationOffers.slice';
import { industriesWithoutOccupation } from './registrationForm.constants';
import {
  getValidationErrors,
  mapRegistrationCompletedEventData,
} from './registrationForm.utils';

startListening({
  actionCreator: fetchRegistrationConfig.fulfilled,
  effect: (action, { dispatch, getState }) => {
    const configId = action.payload.id;
    const state = getState();
    const formDataConfigId = selectRegistrationFormConfigId(state);

    if (!formDataConfigId) {
      dispatch(setFormDataConfigId(configId));
    } else if (configId !== formDataConfigId) {
      dispatch(resetRegistrationData());
      dispatch(resetMarketingMeta());
      dispatch(setFormDataConfigId(configId));
    }
  },
});

startListening({
  actionCreator: fetchRegistrationOffers.fulfilled,
  effect: (action, { dispatch, getState }) => {
    const state = getState();
    const { promoId } = selectRegistrationFormData(state);

    if (
      !promoId ||
      !action.payload.items.find(({ promotionId }) => promotionId === promoId)
    ) {
      if (action.payload.items.length === 1) {
        dispatch(
          updateRegistrationData({
            promoId: action.payload.items[0].promotionId,
          }),
        );
      } else if (action.payload.items.length) {
        dispatch(updateRegistrationData({ promoId: -1 }));
      }
    }

    if (action.payload.items[0]?.subTypeMeta?.referrerId) {
      dispatch(
        updateReferrerId(action.payload.items[0]?.subTypeMeta?.referrerId),
      );
    }

    if (action.payload.items.length < 2) {
      dispatch(removeStep('offer'));
    }
  },
});

startListening({
  matcher: isAnyOf(updateRegistrationData, resetRegistrationData.fulfilled),
  effect: (_, { dispatch, getState }) => {
    const state = getState();
    const data = selectRegistrationFormData(state);
    const errors = getValidationErrors(data);

    dispatch(setValidationErrors(errors));
  },
});

startListening({
  actionCreator: updateRegistrationData,
  effect: (action, { dispatch, getState }) => {
    if (!action.payload.industry) {
      return;
    }

    const industry =
      action.payload.industry.charAt(0).toUpperCase() +
      action.payload.industry.slice(1).toLowerCase();

    if (industriesWithoutOccupation.includes(industry)) {
      dispatch(updateRegistrationData({ occupation: industry }));
      dispatch(skipStep('occupation'));
    } else {
      const state = getState();
      const formData = selectRegistrationFormData(state);

      if (industriesWithoutOccupation.includes(formData.occupation)) {
        dispatch(updateRegistrationData({ occupation: '' }));
      }
      dispatch(setReturnToSummary(false));
      dispatch(restoreStep('occupation'));
    }
  },
});

startListening({
  actionCreator: submitRegistrationForm.fulfilled,
  effect: (action, { dispatch }) => {
    const params = mapRegistrationCompletedEventData(action.payload);

    dispatch(trackEvent({ name: 'registration_process_completed', params }));
  },
});
